<template>
  <div class="menu-container" :style="{left: left, top: top }">
    <a
     :class="['menu-item', index === activeIndex && 'menu-item-active']"
     @click="handleClickItem(item)"
     v-for="(item, index) in dataSource"
     :key="item.value">
     {{item.label}}
    </a>
  </div>
</template>

<script>
import _ from 'lodash'
import VueTypes from 'vue-types'
import { scrollTop } from '../../util/methods'
import { DATA_TYPE, anchorData, anchorMap } from './utils'

// 菜单定位的默认 left 值
const MENU_LEFT = 180
// 节流或防抖的时间 ms
const DELAY_TIME = 200

export default {
  name: 'event-detail-menu',
  props: {
    selector: VueTypes.string.def('div'),
    attr: VueTypes.string.def('data-anchor'),
    res: VueTypes.array.def([]),
    showProcedure: VueTypes.bool.def(true),
    showNotice: VueTypes.bool.def(true)
  },
  data () {
    return {
      activeIndex: 0,
      left: MENU_LEFT,
      top: 0
    }
  },
  created () {
    this.getActiveMenuItemIndexWithThrottle = _.throttle(this.getActiveMenuItemIndex, DELAY_TIME)
    window.addEventListener('scroll', this.getActiveMenuItemIndexWithThrottle)
  },
  mounted () {
    const anchorElements = document.querySelectorAll(`${this.selector}[${this.attr}]`)
    this.anchorElements = anchorElements
    this.getMenuPosition()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.getActiveMenuItemIndexWithThrottle)
  },
  computed: {
    imageFile () {
      const type = DATA_TYPE.get('image')
      return this.res?.filter(item => item.type === type) || []
    },
    linkFile () {
      const type = DATA_TYPE.get('link')
      return this.res?.filter(item => item.type === type) || []
    },
    docFile () {
      const types = [DATA_TYPE.get('ppt'), DATA_TYPE.get('word'), DATA_TYPE.get('video')]
      return this.res?.filter(item => types.includes(item.type)) || []
    },
    dataSource: function () {
      if (this.docFile.length === 0) {
        const index = this.findMenuItemIndex(anchorMap.DOWNLOAD_KEY)
        anchorData.splice(index, 1)
      }
      if (this.imageFile.length === 0) {
        const index = this.findMenuItemIndex(anchorMap.REVIEW_KEY)
        anchorData.splice(index, 1)
      }
      if (!this.showProcedure) {
        const index = this.findMenuItemIndex(anchorMap.PROCEDURE_KEY)
        anchorData.splice(index, 1)
      }
      if (!this.showNotice) {
        const index = this.findMenuItemIndex(anchorMap.NOTICE_KEY)
        anchorData.splice(index, 1)
      }
      return anchorData
    }
  },
  methods: {
    findMenuItemIndex (key) {
      const index = anchorData.findIndex(item => item.value === key)
      return index
    },
    handleClickItem (item) {
      window.removeEventListener('scroll', this.getActiveMenuItemIndexWithThrottle)
      const { value } = item
      const index = this.findMenuItemIndex(value)
      const ele = document.querySelector(`${this.selector}[${this.attr}=${value}]`)
      if (!ele) {
        console.warn('没有找到相关锚点元素')
        return
      }
      const doc = document.documentElement || document.body
      this.activeIndex = index
      scrollTop(doc, doc.scrollTop, ele.offsetTop, 500, () => {
        window.addEventListener('scroll', this.getActiveMenuItemIndexWithThrottle)
      })
    },
    getActiveMenuItemIndex () {
      const elements = this.anchorElements
      const doc = document.documentElement || document.body
      const scrollTop = doc.scrollTop
      for (let i = 0; i < elements.length; i++) {
        const ele = elements[i]
        const nextEle = elements[i + 1]
        if (scrollTop < elements[0].offsetTop) {
          // scrollTop 在第一个锚点之前
          this.activeIndex = 0
        } else if (nextEle && scrollTop >= ele.offsetTop && scrollTop < nextEle.offsetTop) {
          // scrollTop 在两个锚点之间
          const key = ele.getAttribute(this.attr)
          const index = this.dataSource.findIndex(item => item.value === key)
          this.activeIndex = index
        } else if (scrollTop >= ele.offsetTop) {
          // scrollTop 在最后一个锚点之后
          this.activeIndex = this.dataSource.length - 1
        }
      }
    },
    getMenuPosition () {
      const headerEle = document.querySelector('.common-header')
      const eventDetailEle = document.querySelector('.event-detail-container')
      const menuLeft = eventDetailEle?.parentNode?.offsetLeft ?? 180
      const { height: headerHeight } = headerEle.getBoundingClientRect()
      this.left = menuLeft + 'px'
      this.top = headerHeight + 20 + 'px'
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-container{
  position: fixed; left: 180px; top: 50%; z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 150px;
  background: #fff;

  .menu-item {
    width: 100%; height: 45px;
    line-height: 45px; text-align: center;
    font-size: 16px; font-weight: 400; font-family: PingFangSC-Regular, PingFang SC; color: #9A9A9A;
    cursor: pointer;

    &-active {
      background:rgba(209, 167, 95, .1);
      color: #D1A75F;
    }
  }
}
</style>
